
@if (featuresReady) {
  <div id="content">
    <div [ngClass]="{ 'menu-collapse-btn-collapsed': isCollapsed }">
      <!-- <p-button (onClick)="onCollapsedClick()" icon="fa fa-bars"></p-button> -->
      <a class="menu-item" (click)="onCollapsedClick()">
        <span class="fa fa-bars"></span>
      </a>
    </div>
    @if (userProfileUiEnabled) {
      <div [ngClass]="{ 'hide-content': isCollapsed }">
        <app-user-profile></app-user-profile>
      </div>
    }
    @for (item of routes; track item) {
      <div [ngClass]="{ 'hide-content': !isCollapsed && userProfileUiEnabled }">
        <a class="menu-item" (click)="onRouteClick(item)" role="button">
          <span class="{{item.icon}}"></span>
          <span class="item-name">{{item.name}}</span>
          @if ((item.subroutes?.length ?? 0) > 0) {
            <span class="collapsable glyphicon" [ngClass]="{'glyphicon-menu-down': !item.showSub, 'glyphicon-menu-up': item.showSub}"></span>
          }
        </a>
        @if ((item.subroutes?.length ?? 0) > 0) {
          <div class="submenu" [ngClass]="{'hidden': !item.showSub}">
            @for (subroute of (item.subroutes ?? []); track subroute) {
              <a class="submenu-item" (click)="onRouteClick(subroute)" role="button">
                <span class="item-name">{{subroute.name}}</span>
              </a>
            }
          </div>
        }
      </div>
    }
    @if (companyAdministrationFeatureEnabled && isCollapsed) {
      <div>
        <a class="menu-item" routerLink="/requests" role="button">
          <span class="far fa-envelope"></span>
          <span class="item-name">Requests</span>
        </a>
      </div>
    }
  </div>
}
